export default __webpack_public_path__ + "static/media/QA-grey.61799030.svg";